export default __webpack_public_path__ + "static/media/circleBg.b225a296.svg";